/* 2 Rent Curaçao theme — header, motion, filters, FAQ, currency, booking form */
(function () {
  'use strict';
  var RC = window.RC || { booking: {}, t: {} };
  var T = RC.t || {};
  var B = RC.booking || {};
  var doc = document;
  var body = doc.body;
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function $(sel, root) { return (root || doc).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function fmt(str, vars) { var o = String(str || ''); var map = { count: '__N__', hours: '__H__' }; for (var k in vars) { o = o.split(map[k] || k).join(vars[k]).split('{{ ' + k + ' }}').join(vars[k]); } return o; }
  function goTo(el, focusEl) {
    if (!el) return;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (focusEl) setTimeout(function () { try { focusEl.focus({ preventScroll: true }); } catch (e) { focusEl.focus(); } }, reduce ? 0 : 550);
  }

  /* ---------- scroll entrance motion ---------- */
  if (!reduce && !body.classList.contains('no-anim') && 'IntersectionObserver' in window) {
    body.classList.add('motion');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    $$('.reveal, .stagger').forEach(function (el) { io.observe(el); });
    doc.addEventListener('shopify:section:load', function (ev) { $$('.reveal, .stagger', ev.target).forEach(function (el) { el.classList.add('in'); }); });
  }

  /* ---------- header: scrolled state, mobile menu, language menu ---------- */
  var hdr = $('[data-header]');
  function onScroll() { if (hdr) hdr.classList.toggle('scrolled', window.scrollY > 40); }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  var menuBtn = $('[data-menu-btn]');
  function setMenu(open) {
    if (!hdr || !menuBtn) return;
    hdr.classList.toggle('open', open);
    document.body.classList.toggle('menu-open', open);
    menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    menuBtn.setAttribute('aria-label', open ? menuBtn.getAttribute('data-label-close') : menuBtn.getAttribute('data-label-open'));
  }
  if (menuBtn) menuBtn.addEventListener('click', function () { setMenu(!hdr.classList.contains('open')); });
  $$('#mobile-menu a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
  var langBtn = $('[data-lang-btn]');
  var langMenu = $('#lang-menu');
  function setLang(open) { if (!langBtn) return; langBtn.setAttribute('aria-expanded', open ? 'true' : 'false'); langMenu.classList.toggle('open', open); }
  if (langBtn && langMenu) {
    langBtn.addEventListener('click', function (e) { e.stopPropagation(); setLang(langBtn.getAttribute('aria-expanded') !== 'true'); });
    doc.addEventListener('click', function (e) { if (!langMenu.contains(e.target)) setLang(false); });
  }
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (langBtn && langBtn.getAttribute('aria-expanded') === 'true') { setLang(false); langBtn.focus(); }
    if (hdr && hdr.classList.contains('open')) { setMenu(false); menuBtn.focus(); }
  });

  /* ---------- CTA buttons: scroll to the booking form when this page has one ---------- */
  var form = $('[data-booking]');
  $$('[data-cta]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!form) return;
      e.preventDefault(); setMenu(false);
      goTo(form, $('#f-pick-date'));
    });
  });

  /* ---------- currency (EUR / USD) ---------- */
  var rate = parseFloat(String(RC.usdRate || '1.14').replace(',', '.')) || 1.14;
  function money(eur, cur) {
    var v = parseFloat(eur);
    if (cur === 'USD') return '$' + Math.round(v * rate);
    return '€' + (v % 1 ? v.toFixed(2).replace('.', ',') : v);
  }
  function setCur(cur) {
    $$('[data-cur]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cur') === cur ? 'true' : 'false'); });
    if (!$('[data-cur]')) cur = 'EUR';
    $$('[data-price-eur]').forEach(function (el) { el.textContent = money(el.getAttribute('data-price-eur'), cur); });
    $$('[data-usd-note]').forEach(function (el) { el.hidden = cur !== 'USD'; });
    try { localStorage.setItem('rc-cur', cur); } catch (e) {}
  }
  var saved = 'EUR';
  try { saved = localStorage.getItem('rc-cur') === 'USD' ? 'USD' : 'EUR'; } catch (e) {}
  $$('[data-cur]').forEach(function (b) { b.addEventListener('click', function () { setCur(b.getAttribute('data-cur')); }); });
  if (saved === 'USD') setCur('USD');

  /* ---------- FAQ accordion (one open per group) ---------- */
  $$('.acc-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.acc');
      var group = btn.closest('[data-faq]') || doc;
      var willOpen = !item.classList.contains('open');
      $$('.acc', group).forEach(function (a) { a.classList.remove('open'); var b = $('.acc-btn', a); if (b) b.setAttribute('aria-expanded', 'false'); });
      if (willOpen) { item.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });

  /* ---------- car filters ---------- */
  function applyFilter(root, type) {
    var n = 0;
    $$('.fleet > li[data-cat]', root).forEach(function (li) {
      var show = type === 'all' || li.getAttribute('data-cat') === type || (type === 'suv' && /^suv/.test(li.getAttribute('data-cat')));
      li.hidden = !show; if (show) n++;
    });
    $$('.fpill', root).forEach(function (p) { p.setAttribute('aria-pressed', p.getAttribute('data-filter') === type ? 'true' : 'false'); });
    var c = $('[data-count]', root);
    if (c) c.textContent = fmt(n === 1 ? T.countOne : T.countMany, { count: n });
  }
  $$('[data-fleet]').forEach(function (root) {
    $$('.fpill', root).forEach(function (p) { p.addEventListener('click', function () { applyFilter(root, p.getAttribute('data-filter')); }); });
  });
  var firstFleet = $('[data-fleet]');
  var qType = (location.search.match(/[?&]type=([a-z-]+)/) || [])[1];
  if (firstFleet && qType) applyFilter(firstFleet, qType);
  $$('[data-show-type]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!firstFleet) return;
      e.preventDefault();
      applyFilter(firstFleet, a.getAttribute('data-show-type'));
      goTo(firstFleet);
    });
  });

  /* ---------- product thumbnails ---------- */
  $$('.thumb').forEach(function (t, i) {
    if (i === 0) t.setAttribute('aria-current', 'true');
    t.addEventListener('click', function () {
      var img = $('.pdp-media > img');
      if (img) { img.removeAttribute('srcset'); img.src = t.getAttribute('data-thumb'); }
      $$('.thumb').forEach(function (x) { x.removeAttribute('aria-current'); });
      t.setAttribute('aria-current', 'true');
    });
  });

  /* ---------- floating WhatsApp button: always visible; greeting bubble once per visit ---------- */
  var wa = $('[data-wa]');
  if (wa) {
    var msg = $('[data-wa-msg]', wa);
    var seen = false;
    try { seen = sessionStorage.getItem('rc-wa-seen') === '1'; } catch (err) {}
    if (msg && !seen) {
      setTimeout(function () { msg.hidden = false; }, 6000);
    }
    var hideMsg = function () { if (msg) msg.hidden = true; try { sessionStorage.setItem('rc-wa-seen', '1'); } catch (err) {} };
    var closeBtn = $('[data-wa-close]', wa);
    if (closeBtn) closeBtn.addEventListener('click', hideMsg);
    $$('a', wa).forEach(function (a) { a.addEventListener('click', hideMsg); });
  }

  /* ---------- booking form ---------- */
  if (!form) return;
  var f = $('[data-booking-form]', form);
  var sel = { pickDate: $('#f-pick-date'), pickTime: $('#f-pick-time'), retDate: $('#f-ret-date'), retTime: $('#f-ret-time'), location: $('#f-location'), address: $('#f-address'), vehicle: $('#f-vehicle') };
  var order = ['pickDate', 'pickTime', 'retDate', 'retTime', 'location', 'address', 'vehicle'];
  var addrWrap = $('[data-address]', form);
  var esum = $('[data-esum]', form);
  var sentBox = $('[data-sent]', form);
  var submitted = false;
  var pre = form.getAttribute('data-preselect');
  if (pre && sel.vehicle) sel.vehicle.value = pre;

  /* Date & time: open the calendar/clock on a click anywhere in the field, not only on the small icon */
  function iso(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  var todayIso = iso(new Date());
  [sel.pickDate, sel.retDate].forEach(function (el) { if (el && !el.min) el.min = todayIso; });
  [sel.pickDate, sel.pickTime, sel.retDate, sel.retTime].forEach(function (el) {
    if (!el) return;
    el.addEventListener('click', function () {
      if (typeof el.showPicker === 'function') { try { el.showPicker(); } catch (err) {} }
    });
  });
  if (sel.pickDate && sel.retDate) {
    sel.pickDate.addEventListener('change', function () {
      var v = sel.pickDate.value; if (!v) return;
      var r = new Date(v + 'T12:00'); r.setDate(r.getDate() + (B.minDays || 0));
      var minRet = iso(r);
      sel.retDate.min = minRet;
      if (!sel.retDate.value || sel.retDate.value < minRet) sel.retDate.value = minRet;
    });
  }

  function val(k) { return sel[k] ? String(sel[k].value || '').trim() : ''; }
  function ts(d, t) { if (!d || !t) return null; var x = new Date(d + 'T' + t); return isNaN(x.getTime()) ? null : x.getTime(); }
  function validate() {
    var e = {}, min = parseInt(B.minDays, 10) || 0;
    if (!val('pickDate')) e.pickDate = T.errPickDate;
    if (!val('pickTime')) e.pickTime = T.errPickTime;
    if (!val('retDate')) e.retDate = T.errRetDate;
    if (!val('retTime')) e.retTime = T.errRetTime;
    var p = ts(val('pickDate'), val('pickTime')), r = ts(val('retDate'), val('retTime'));
    if (p && p < Date.now() - 300000) e.pickDate = T.errPast;
    if (p && r) {
      if (r <= p) e.retDate = T.errOrder;
      else if (min > 0 && (r - p) < min * 86400000) e.retDate = fmt(T.errMin, { count: min, hours: min * 24 });
    }
    if (!val('location')) e.location = T.errLocation;
    if (val('location') && val('location') !== 'airport' && !val('address')) e.address = T.errAddress;
    if (!val('vehicle')) e.vehicle = T.errVehicle;
    return e;
  }
  function showErrors(e) {
    order.forEach(function (k) {
      var box = doc.getElementById('e-' + k);
      if (!box || !sel[k]) return;
      box.textContent = e[k] || ''; box.hidden = !e[k];
      sel[k].setAttribute('aria-invalid', e[k] ? 'true' : 'false');
    });
    if (esum) esum.hidden = !Object.keys(e).length;
  }
  function syncAddress() { if (addrWrap) addrWrap.hidden = !val('location') || val('location') === 'airport'; }
  order.forEach(function (k) {
    if (!sel[k]) return;
    sel[k].addEventListener('change', function () { syncAddress(); if (sentBox) sentBox.innerHTML = ''; if (submitted) showErrors(validate()); });
  });
  syncAddress();

  function locLabel() { var o = sel.location.options[sel.location.selectedIndex]; return o ? o.text : ''; }
  function vehLabel() { var o = sel.vehicle.options[sel.vehicle.selectedIndex]; return val('vehicle') === 'No preference' ? T.noPreference : (o ? o.text : ''); }
  function dateText(ms) {
    var d = new Date(ms), loc = RC.locale || 'en';
    try { return d.toLocaleDateString(loc, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }) + ', ' + d.toLocaleTimeString(loc, { hour: '2-digit', minute: '2-digit' }); }
    catch (e) { return d.toString(); }
  }
  function lines() {
    var p = ts(val('pickDate'), val('pickTime')), r = ts(val('retDate'), val('retTime'));
    var days = Math.ceil((r - p) / 86400000);
    var out = [T.pickup + ': ' + dateText(p), T.ret + ': ' + dateText(r) + ' (' + days + ' ' + (days === 1 ? T.day : T.days) + ')', T.location + ': ' + locLabel()];
    if (val('location') !== 'airport' && val('address')) out.push(T.address + ': ' + val('address'));
    out.push(T.car + ': ' + vehLabel());
    return out;
  }
  function waLink(text) { return 'https://wa.me/' + String(B.whatsapp || '').replace(/[^0-9]/g, '') + '?text=' + encodeURIComponent(text); }
  function hqLink() {
    var u; try { u = new URL(B.hqUrl); } catch (e) { return B.hqUrl; }
    var P = B.hqParams || {};
    function set(name, v) { if (name && v) u.searchParams.set(name, v); }
    set(P.pickDate, val('pickDate')); set(P.pickTime, val('pickTime')); set(P.retDate, val('retDate')); set(P.retTime, val('retTime'));
    var lo = sel.location.options[sel.location.selectedIndex]; set(P.location, lo && lo.getAttribute('data-hq'));
    var vo = sel.vehicle.options[sel.vehicle.selectedIndex]; set(P.vehicle, vo && vo.getAttribute('data-hq'));
    return u.toString();
  }
  function prefill() { var P = B.hqParams || {}; return Object.keys(P).some(function (k) { return !!P[k]; }); }
  function el(tag, attrs, text) { var n = doc.createElement(tag); for (var k in attrs) n.setAttribute(k, attrs[k]); if (text != null) n.textContent = text; return n; }

  f.addEventListener('submit', function (ev) {
    ev.preventDefault();
    submitted = true;
    var e = validate(); showErrors(e);
    if (Object.keys(e).length) { var first = order.filter(function (k) { return e[k]; })[0]; if (sel[first]) sel[first].focus(); return; }
    var summary = lines();
    var msg = [T.waHello, T.waNote, ''].concat(summary, ['', T.waClose]).join('\n');
    var hq = B.mode === 'hq' && !!B.hqUrl;
    var url = hq ? hqLink() : waLink(msg);
    try { window.open(url, '_blank', 'noopener'); } catch (err) {}
    sentBox.innerHTML = '';
    var box = el('div', { 'class': 'sent', role: 'status' });
    box.appendChild(el('h3', {}, hq ? T.hqTitle : T.waTitle));
    box.appendChild(el('p', {}, hq ? (prefill() ? T.hqTextPrefill : T.hqText) : T.waText));
    box.appendChild(el('pre', {}, hq ? summary.join('\n') : msg));
    var acts = el('div', { 'class': 'sent-actions' });
    acts.appendChild(el('a', { 'class': 'btn btn-primary btn-sm', href: url, target: '_blank', rel: 'noopener' }, hq ? T.hqOpen : T.waOpen));
    if (hq && B.whatsapp) acts.appendChild(el('a', { 'class': 'btn btn-outline btn-sm', href: waLink(msg), target: '_blank', rel: 'noopener' }, T.waInstead));
    if (!hq && B.email) acts.appendChild(el('a', { 'class': 'btn btn-outline btn-sm', href: 'mailto:' + B.email + '?subject=' + encodeURIComponent(T.mailSubject) + '&body=' + encodeURIComponent(msg) }, T.mailInstead));
    var edit = el('button', { 'class': 'btn btn-outline btn-sm', type: 'button' }, T.edit);
    edit.addEventListener('click', function () { sentBox.innerHTML = ''; sel.pickDate.focus(); });
    acts.appendChild(edit);
    box.appendChild(acts);
    sentBox.appendChild(box);
  });

  /* enquire buttons on car cards / featured car */
  $$('[data-enquire]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (sel.vehicle) sel.vehicle.value = btn.getAttribute('data-enquire');
      if (sentBox) sentBox.innerHTML = '';
      if (submitted) showErrors(validate());
      goTo(form, sel.pickDate);
    });
  });
})();
